export const clientCode: string="HOOPPMEMBER";